import React from "react";
import Layout from "../components/App/Layout";
import SEO from "../components/App/SEO";

const Privacy = () => {
  return (
    <Layout>
      <SEO />

      <section className="featured-services-area pt-100 pb-70">
        <div className="container privacy-terms">
          <br />
          <h3>隐私政策</h3>
          <br />
          <p>尊敬的用户，我们对《大任软件隐私政策》进行了更新，此版本更新主要是进一步详细明确了平台收集、使用您的个人信息的规则。</p>
          <p>
            大任软件非常重视用户的隐私和个人信息保护。您在使用我们服务时，我们可能会收集和使用您的相关信息。我们希望通过《大任软件隐私政策》（以下简称“本隐私政策”）帮助您了解我们会收集哪些信息、为什么收集这些信息，会利用这些信息做些什么及如何保护这些信息。了解这些内容对于您行使隐私权及保护您的个人信息至关重要。
          </p>
          <p>
            请您在使用我们服务前仔细阅读此《大任软件隐私政策》（尤其是字体加粗及下划线的内容）并充分理解本隐私政策的全部内容，确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可联系我们进行咨询；一旦您继续访问或使用大任软件，即表示您同意此等隐私政策，授权并接受我们按照本隐私政策的规定收集、保存、使用、共享、披露您的信息。如您不同意协议中的任何条款，您应立即停止访问大任软件及使用相关服务。
          </p>
          <p>本隐私政策适用于您通过任何方式(包括但不限于网站、APP等)对大任软件各项服务的访问和使用。</p>
          <p>本隐私政策的相关术语，在未作特别说明的情况下可参照《大任软件用户协议》。</p>
          <h5>一、个人信息的收集及用途</h5>
          <p>
            根据国家法律法规的规定，网络运营者为用户提供信息发布、即时通讯等服务，在与用户签订协议或者确认提供服务时，应当要求用户提供真实身份信息。用户不提供真实身份信息的，网络运营者不得为其提供相关服务。为了符合法律法规要求并更好地为您提供服务，我们将收集并使用您的个人信息。我们承诺将坚持“最小必要化”原则收集、使用、存储和传输用户信息，并通过用户协议和隐私政策告知您相关信息的使用目的和范围。
          </p>
          <h6>（ 一 ）个人信息的定义</h6>
          <p>个人信息，是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定 自然人活动情况的各种信息，在本隐私政策中涉及的个人信息包括但不限于：</p>
          <p>1. 基本信息：包括个人姓名、部门、岗位、性别、身份证号码、电话号码、工作经历、教育经历、社会关系等；</p>
          <p>2. 考勤信息：个人证件、面部特征等;</p>
          <p>3. 账号信息：包括系统账号、IP地址、邮箱地址及与前述有关的密码等;</p>
          <p>5. 个人薪酬信息：包括每个月企业发薪明细的各项数据与社保、公积金、个税等信息;</p>
          <p>6. 个人上网记录：包括网站及APP登录记录、浏览记录、使用记录、点击记录、操作记录等;</p>
          <p>7. 个人常用设备信息：包括硬件型号、设备 MAC 地址、操作系统类型、设备识别码等;</p>
          <p>8. 个人位置信息：包括定位信息等。</p>
          <p>如无特别说明，本《隐私政策》中使用的特定词语，均遵循以上定义。</p>
          <h6>（ 二 ）为使用基本功能/服务用户须提供并授权平台收集、使用的信息</h6>
          <p>
            在您使用平台基本功能/服务的过程中，我们将收集、保存和使用下列与您有关的信息。如果您不提供相关信息，您将无法使用平台的服务/具体功能。请您注意，您在使用平台服务/功能时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。部分个人信息的收集，需要您同意调取所使用设备的相应系统权限，具体参见第本条款第（五）部分需要您授权同意调取系统权限的情形。这些服务/功能包括但不限于：
          </p>
          <p>1. 定位功能</p>
          <p>平台提供了考勤打卡的功能，为此平台需要使用个人位置等信息。</p>
          <p>2. 存储功能</p>
          <p>平台提供了个人信息查看、修改、新增等功能，为此平台需要使用本地存储功能。</p>
          <p>3. 客服功能</p>
          <p>您在使用服务的过程中，可能会向客服渠道提出任何问题、意见、建议、投诉、举报等需求。为此我们需收集、使用上述个人信息中的(部分/全部)相关内 容。</p>
          <p>4. 安全校验功能</p>
          <p>在您使用平台服务时，我们需获取您的设备信息（包括mac地址等），当您的账号在陌生设备登录APP时进行安全校验，以便及时向您提醒可能存在的安全隐患。</p>
          <p>5. 其他功能</p>
          <p>本平台对该信息的采集、传输及存储均会采取加密、防泄露等相关措施。</p>
          <h6>（ 三 ）改进产品与/或服务所必须的功能：</h6>
          <p>当您登录平台的网页或使用平台APP时，我们的服务器会自动记录您的日志信息，例如您的登录记录、输入的搜索关键词信息、点击的内容，您发布的报错信息、反馈和评论信息，您上传的图片信息、您的IP</p>
          <p>
            地址、浏览器的类型和使用的语言、硬件设备信息、操作系统的版本、网络运营商的信息、您访问服务的日期、时间、时长等。为了给您带来更便捷的服务，我们可能会收集您设备上的信息并进行本地存储。我们会：
          </p>
          <p>
            1. 用于产品功能改进：如统计我们产品的用户数量、分析产品的使用状况、网页升级改版、浏览器兼容性检测、排查崩溃原因、减少崩溃情况、监测广告投放情况、改进产品BUG、优化产品的稳定性及功能性等。
          </p>
          <h6>（ 四 ）使用第三方SDK收集、使用您的个人信息</h6>
          <p>“高德地图amap”， 由“高德”提供，用于“考勤打卡定位功能”，需要收集或使用的个人信息/设备权限包括：设备信息（IMEI号）、存储权限、网络状态、位置权限。</p>
          <h6>（ 五 ）需要您授权同意调取系统权限的情形</h6>
          <p>
            在为您提供前述基本功能/服务，改进产品与/或服务或使用第三方SDK收集使用您的个人信息时，部分场景的实现依赖于您同意平台（App）调取您所使用设备的相应系统权限。您可以在您的终端设备中逐项查看您上述权限的开启状态，并可以随时开启或关闭这些权限。请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理：
          </p>
          <p>1. 定位权限：我们会收集您的位置信息（我们仅收集您当时所处的地理位置）来判断您所处的地点，用于考勤签到。</p>
          <p>2. 相册权限：上传图片用于账号头像设置、休假证明上传等。</p>
          <p>3. 存储权限：您可以调用您设备外部存储中的文件（比如文档文件、照片等）用于上传休假证明、编辑个人头像等；也可以相应下载、保存各类文件至外部存储中。</p>
          <p>4. 通知权限：开启通知权限后，平台才能向您发送各类服务通知。</p>
          <h6>（ 六 ）无需征得授权的情形</h6>
          <p>根据国家法律法规的相关规定及特定事项的需求，平台在以下情况无需经过您的授权即可收集并使用您的个人信息，您知晓并充分理解此等情形：</p>
          <p>1. 与国家安全、国防安全有关的;</p>
          <p>2. 与公共安全、公共卫生、重大公共利益有关的;</p>
          <p>3. 与犯罪侦查、起诉、审判和判决执行等有关的;</p>
          <p>4. 出于维护个人信息主体或其他个人的生命、财产等重大合法权益的;</p>
          <p>5. 所收集的个人信息是个人信息主体自行向社会公众公开的;</p>
          <p>6. 从合法公开披露的信息中收集的您的信息的，如企业的新闻报道、政府信息公开等渠道;</p>
          <p>7. 根据您的要求签订合同所必需的;</p>
          <p>8. 用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障;</p>
          <p>9. 为合法的新闻报道所必需的;</p>
          <p>10. 统计机构、学术研究机构、政府公共部门等基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的;</p>
          <p>11. 法律法规规定的其他情形。</p>
          <h6>（ 七 ) 个人信息去标识化后的使用</h6>
          <p>
            在收集您的信息后，我们可以通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。您了解并同意，在此情况下我们有权使用已经去标识化的信息;并对您的个人信息进行脱敏处理的前提下，我们有权对用户数据库进行分析并予以商业化的利用。比如，我们会对我们服务使用情况进行统计，但这些统计信息不包含您的任何身份识别与敏感数据信息。
          </p>
          <h5>二、 个人信息的共享、披露及转让</h5>
          <h6>（ 一) 共享</h6>
          <p>1. 我们不会与成都市大任软件有限责任公司及关联公司以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</p>
          <p>(1)事先获得您明确的同意或授权；</p>
          <p>(2)只有共享您的信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务；</p>
          <p>(3)产品与/或服务的提供包含、依赖于第三方的服务（例如基于第三方SDK实现的部分功能）。</p>
          <p>(4)符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</p>
          <p>(5)基于符合法律法规的社会公共利益而共享</p>
          <p>2. 基于上述情况与关联方、第三方共享您的个人信息时，我们只会共享必要的个人信息。我们的关联方、第三方如果改变个人信息的使用目的应再次征求您的授权同意。</p>
          <h6>（ 二)转让</h6>
          <p>除以下情形外，我们不会将您的个人信息转让给除大任及其关联公司外的第三方：</p>
          <p>1. 事先获得您的明确授权或同意;</p>
          <p>2. 满足法律法规、法律程序的要求或强制性的政府要求或司法裁定;</p>
          <p>
            3.
            如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性，并尽量确保在转移后继续受到其他隐私权政策的约束。
          </p>
          <h6>（ 三)披露</h6>
          <p>在以下情况，且相应采取了达到行业普遍保护措施的情况下，我们才会披露您的个人信息：</p>
          <p>1. 您明确授权或同意。</p>
          <p>2. 与国家安全、国防安全、公共安全、公共卫生、重大公共利益有关的;</p>
          <p>3. 与犯罪侦查、起诉、审判和判决执行等有关的;</p>
          <p>4. 根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供;</p>
          <p>5. 在法律法规允许的范围内，为维护用户或社会公众利益、财产或安全免遭损害而有必要提供;</p>
          <p>6. 为处理您与他人的纠纷或争议;</p>
          <p>7. 符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供。</p>
          <p>8. 基于符合法律法规的社会公共利益而披露。</p>
          <h5>三、信息的保护</h5>
          <p>我们非常重视信息的保护，并尽可能的采取各种措施。在信息安全管理方面，达到经营本网站业务所相适用的水平。</p>
          <h6>（ 一) 从技术手段上</h6>
          <p>我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据时受</p>
          <p>
            SSL协议加密保护，同时对大任软件提供HTTPS协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
          </p>
          <p>我们有行业先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。</p>
          <p>
            但由于技术的限制以及可能存在的各种恶意手段，平台不承诺您的信息的绝对安全。如出现第三方采取不正当手段获取用户个人信息的，在平台已按照法律法规及本隐私政策履行网络运营者应尽的义务情况下，本平台不承担额外的责任。
          </p>
          <h6>（ 二) 从规则制度上</h6>
          <p>1. 内部制度</p>
          <p>
            大任设置了专门部门及岗位负责信息安全保障工作(岗位和人员可能会随公司发展而变动)，利用技术手段实时监测平台运营状况，并合理分配设置不同工作人员后台系统权限;与此同时大任还与每名员工签订《保密协议》，以确保内部有着完善的信息安全管理制度。另外，我们也在不断完善信息安全相关制度规则，以及加强对员工的信息安全教育工作等。
          </p>
          <p>2. 对于平台其他用户或其他第三方</p>
          <p>如涉及向平台其他用户或其他第三方共享、转让、披露用户个人信息的情形，我们同样会要求他们遵守相关规则，包括平台用户协议、本隐私政策、签署的相关协议中的保密条款等。</p>
          <h6>（三) 安全事件</h6>
          <p>
            为了应对可能的网络攻击、安全漏洞、信息泄露等风险事件，平台内部制定了相应的安全事件应急预案。一旦发生相关事件，我们将迅速处理并按照法律法规要求上报政府相关部门;同时，我们也将按照法律法规的要求及时向您通知：
          </p>
          <p>
            安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。此等通知将以邮件、信函、电话、推送通知等方式呈现，如果难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
          </p>
          <p>如果您发现了任何有关平台的潜在安全风险(如系统漏洞等)或者个人信息安全事件，您可以向平台及时反馈并联系我们。</p>
          <h5>四、用户对个人信息的管理</h5>
          <h6>（一) 编辑信息</h6>
          <p>如果您是企业员工呢，您可以通过PC端网页—“点击首页—个人中心”或者APP端“我的”功能模块——我的档案来对您的在线简历进行修订、更正、补充等。</p>
          <h6>（二)审批信息</h6>
          <p>在平台上办理个人流程审批，进行个人流程事物的提交与审批。</p>
          <p>以上具体操作流程可能会随着本网站升级而发生调整，我们将通过适当形式来通知您并对操作进行引导。</p>
          <h5>五、隐私政策的更新</h5>
          <p>随着平台经营的发展，本隐私政策将不时更新。我们会通过在网站公告、APP端推送、电子邮件等其他适当方式提醒您相关内容的更新。你也可以随时访问我们的隐私政策页面来获知最新版本。</p>
          <p>对于重大变更（我们收集和使用您个人信息方式的变化将导致您的权利实质性的减少或义务的实质性增多）我们会采用更为显著的通知方式。</p>
          <p>在您知晓或应当知晓上述更新后，您仍然选择继续是使用我们的服务，视为您对更新的接受。</p>
          <h5>六、联系我们</h5>
          <p>关于本隐私政策及个人信息的任何问题，您可以通过产品的在线反馈功能或如下方式同我们联系：</p>
          <p>电话：028-85175002 (工作日 9：00-18：00) 邮箱：service@darensoft.com，通讯地址：成都市高新区天府软件园E6-1116。邮政编码：610042，收件人：大任软件客户服务中心</p>
          <p>为了核查您的问题并及时向您反馈，我们可能需要您提交身份证明、有效联系方式和书面请求及相关证据。我们将尽快处理您的问题，您仍然可以按照法律法规规定向有关政府部门进行反馈。</p>
          <p style={{ textAlign: "right" }}>更新时间: 2020年7月18日&nbsp;&nbsp;&nbsp;&nbsp;生效时间: 2020年7月18日</p>
        </div>
      </section>
    </Layout>
  );
};

export default Privacy;
